import RoutesEnum from 'enums/routes.enum'
import ForbidSubdomainMiddleware from 'middlewares/ForbidSubdomainMiddleware'

export default [
    {
        path: '/accept-invitation',
        name: RoutesEnum.INVITATION.ACCEPT_INVITATION,
        view: 'invitation/AcceptInvitation',
        middlewares: [ForbidSubdomainMiddleware],
        meta: {
            layout: 'simple',
            title: 'Prihvatanje Poziva | Bookeraj',
            description:
                'Prihvatite poziv i pridružite se našoj platformi. Pratite pruženi link ili uputstva kako biste prihvatili poziv i postali član.',
        },
    },
]
